import React from 'react';

import { Row } from '~components/table-view-v3';

interface ComponentProps {
  row: Row;
}

type ClaimStatus = 'not_claimed' | 'part_claimed' | 'claimed';

const STATUS_LABELS: Record<ClaimStatus, string> = {
  not_claimed: 'Not Claimed',
  part_claimed: 'Part Claimed',
  claimed: 'Claimed',
};

const STATUS_COLOURS: Record<ClaimStatus, string> = {
  not_claimed: '#adb5bd',
  part_claimed: '#fd7e14',
  claimed: '#198754',
};

function deriveClaimStatus(items: Row[]): ClaimStatus {
  if (!items?.length) return 'not_claimed';
  const claimedCount = items.filter((item) => item.is_claimed).length;
  if (claimedCount === 0) return 'not_claimed';
  if (claimedCount === items.length) return 'claimed';
  return 'part_claimed';
}

const ClaimStatusBadge: React.FC<ComponentProps> = ({ row }) => {
  const status = deriveClaimStatus(row.items ?? []);
  const label = STATUS_LABELS[status];
  const colour = STATUS_COLOURS[status];

  return (
    <div className="status-block-L" style={{ borderLeft: `6px solid ${colour}` }}>
      {label}
    </div>
  );
};

export default ClaimStatusBadge;
